import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import React, { useEffect, useState } from 'react';
import relationships from 'Consts/Relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import View from './View';

const EDUCATION_ACCOUNT = 'education_account';

const Controller = () => {
  const { householdResource } = useSimpleHousehold();
  const [accountsCollection, setAccountsCollection] = useState();
  const [dependentsResources, setDependentsResources] = useState();

  const getAccountsOfType = (accountType) => {
    if (!accountsCollection) {
      return [];
    }
    const result = accountsCollection.resources().list().filter(account => account.attr('accountType') === accountType);
    return result !== undefined ? result : [];
  };

  const injectDependentsIntoToAccountResources = (accounts) => {
    if (dependentsResources === undefined) {
      return accounts;
    }

    return accounts.map((account) => {
      const dependent = dependentsResources.find(element => element.id().toString() === account.attr('dependentId'));
      if (dependent !== undefined) {
        account.attr('dependent', dependent);
      }
      return account;
    });
  };

  const refreshAccounts = async () => {
    const newAccountsCollection = await householdResource.relationship(relationships.accounts).link('related').get();
    setAccountsCollection(newAccountsCollection);

    const newClientsWithDependentsCollection = await householdResource.relationship(relationships.clientsWithDependents).link('related').get();
    const newDependentsResources = newClientsWithDependentsCollection.resources().list().filter(clientOrChild => clientOrChild.type() === 'child' || clientOrChild.type() === 'dependent');
    setDependentsResources(newDependentsResources);

    return Promise.resolve();
  };

  useEffect(() => {
    if (householdResource !== undefined) {
      refreshAccounts()
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  return (
    <View
      collegeEducationAccounts={injectDependentsIntoToAccountResources(getAccountsOfType(EDUCATION_ACCOUNT))}
    />
  );
};
Controller.propTypes = {
};

export default Controller;
